<script>
export let width;
</script>

<svg
    {width}
    height={width}
    id="cnnlogo"
    viewBox="0 0 500 500"
    preserveAspectRatio="xMidYMid meet"
>
    <g>
        <rect x="0.3" fill="#cc0000 " width="500" height="500" />
        <g>
            <path
                d="M106.1,249.9c0-19.7,16-38.5,35.6-38.5h29.1v-19.3h-29.3c-30.8,0-55.8,27-55.8,57.8
    c0,30.8,25,57.8,55.8,57.8H194c2.9,0,5.7-4.8,5.7-7.2V197.1c0-5.7,3.4-10.5,8.7-12c4.5-1.2,10.8,0,15.1,7.2
    c0.2,0.3,13,22.6,32.7,56.4c15.4,26.6,31.4,54.1,31.6,54.6c1.6,2.8,3.5,4.1,5.6,3.5c1.4-0.4,2.5-1.7,2.5-4.2V197.1
    c0-5.7,4-10.5,9.3-12c4.5-1.2,11,0,15.3,7.2c0.2,0.3,11.7,20,30.5,52.3c16.6,28.6,33.8,58.2,34.1,58.7c1.7,2.8,3,4.1,5.1,3.5
    c1.4-0.4,2-1.7,2-4.2V163.3H373v84.1c0,0-33.3-58.2-34.8-60.9c-21.5-36.5-61.5-21.4-61.5,10v50.9c0,0-33.3-58.2-34.8-60.9
    c-21.5-36.5-61.5-21.4-61.5,10v83.4c0,3-3.5,8.6-6.9,8.6h-31.8C122.1,288.4,106.1,269.6,106.1,249.9z"
                fill="#fff"
            />
            <path
                d="M401.9,163.3v139.5c0,5.7-3.4,10.5-8.7,12c-1,0.3-1.9,0.4-3.1,0.4c-4,0-8.6-2-12-7.7
    c-0.2-0.3-13.6-23.5-34.1-58.8c-14.8-25.5-30-51.8-30.3-52.3c-1.6-2.8-3.5-4.1-5.6-3.6c-1.3,0.4-2.5,1.7-2.5,4.2v105.7
    c0,5.7-3.9,10.5-9.3,12c-4.5,1.2-11.1,0-15.3-7.2c-0.2-0.3-12.8-21.8-31.8-54.6c-15.9-27.5-32.5-55.9-32.8-56.4
    c-1.7-2.8-3-4.1-5.1-3.5c-1.4,0.4-2,1.7-2,4.2v103.4c0,7.1-8.2,16.8-15.3,16.8h-52.5c-35.2,0-63.9-32.2-63.9-67.4
    c0-35.2,28.7-67.4,63.9-67.4h29.3v-19.3h-29.3c-46.4,0-84.1,40.2-84.1,86.6c0,46.4,37.7,86.6,84.1,86.6h53c20.1,0,34-14.3,34-36.1
    v-48c0,0,33.2,58.2,34.8,60.9c21.5,36.5,61.5,21.4,61.5-10v-50.9c0,0,33.3,58.2,34.8,60.9c21.5,36.5,61.5,21.4,61.5-10V163.3
    H401.9z"
                fill="#fff"
            />
        </g>
    </g>
</svg>
